<template>
    <div>
        <button @click="modalOpen = true">
            <QrIcon icon="trash-can" class="w-5 h-5 text-red-500"/>
        </button>

        <QrConfirm
            :open="modalOpen"
            @close="modalOpen = false"
            :title="trans('content.delete-content')"
            :body="trans('content.are-you-sure-you-want-do-delete-this-content')"
            :button-text="trans('button.delete')"
            @confirm="confirmed"
        />
    </div>
</template>

<script setup>
import { ref } from "vue";
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import { useQrCodeHomepageStore } from "@/store/qrCodeHomepage.js";
import QrConfirm from "@/components/application-ui/dialogs/QrConfirm.vue";
import { trans } from "@/libs/helper.js";

const homepageStore = useQrCodeHomepageStore();
const props = defineProps({
    content: Object,
});

const modalOpen = ref(false);

const confirmed = async () => {
    await homepageStore.remove(props.content.id)
    modalOpen.value = false
}

</script>
